/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum TransactionStatusEnum {
  "ACTIVATED" = "ACTIVATED",

  "AUTHORIZATION_REQUESTED" = "AUTHORIZATION_REQUESTED",

  "AUTHORIZATION_COMPLETED" = "AUTHORIZATION_COMPLETED",

  "CLOSURE_REQUESTED" = "CLOSURE_REQUESTED",

  "CLOSED" = "CLOSED",

  "CLOSURE_ERROR" = "CLOSURE_ERROR",

  "NOTIFIED_OK" = "NOTIFIED_OK",

  "NOTIFIED_KO" = "NOTIFIED_KO",

  "NOTIFICATION_ERROR" = "NOTIFICATION_ERROR",

  "NOTIFICATION_REQUESTED" = "NOTIFICATION_REQUESTED",

  "EXPIRED" = "EXPIRED",

  "REFUNDED" = "REFUNDED",

  "CANCELED" = "CANCELED",

  "EXPIRED_NOT_AUTHORIZED" = "EXPIRED_NOT_AUTHORIZED",

  "UNAUTHORIZED" = "UNAUTHORIZED",

  "REFUND_ERROR" = "REFUND_ERROR",

  "REFUND_REQUESTED" = "REFUND_REQUESTED",

  "CANCELLATION_REQUESTED" = "CANCELLATION_REQUESTED",

  "CANCELLATION_EXPIRED" = "CANCELLATION_EXPIRED"
}

/**
 * Possible statuses a transaction can be in
 */

export type TransactionStatus = t.TypeOf<typeof TransactionStatus>;
export const TransactionStatus = enumType<TransactionStatusEnum>(
  TransactionStatusEnum,
  "TransactionStatus"
);
